import { Appointment, SUBJECT_KEYS } from "@elixir/types";
import { TooltipComponent } from "ui";
import { ReactComponent as CircleCheckSolidIcon } from "../../../../assets/icons/font-awesome/circle-check.svg";
import { ReactComponent as ClockSolidIcon } from "../../../../assets/icons/font-awesome/clock-solid.svg";
import { ReactComponent as NoteMedicalRegularIcon } from "../../../../assets/icons/font-awesome/note-medical-regular.svg";
import useQueueStore from "../../../../stores/queue-store";
import { getAclViewClassName } from "@elixir/utils";

/**
 * This component opens the new questionnaire flow on queu
 * Sa status is dependent on the new assessments key in the appointment object
 */
const SaQuestionnaireStatus = ({
  apt,
  className = "dr-col-span-2",
}: {
  apt: Appointment;
  className?: string;
}) => {
  const setSelectedAppointment = useQueueStore(
    (state) => state.setSelectedAppointment
  );
  const setOpenQuestionnaireDrawer = useQueueStore(
    (state) => state.setOpenQuestionnaireDrawer
  );

  const {sa_cmpl, assessments = {} } = apt;
  const hasFilledSa = sa_cmpl?.length || (Object.keys(assessments || {}).length > 0);

  const handleSaClick = () => {
    setSelectedAppointment(apt);
    setOpenQuestionnaireDrawer(true);
  };

  return (
    <TooltipComponent title="Health Assessment" placement="top">
      <div
        onClick={handleSaClick}
        className={`BodyBody2Regular dr-text-darwin-touch-neutral-1000 dr-py-7 dr-px-8 dr-border-1 dr-border-darwin-touch-neutral-100 dr-rounded-4 dr-space-x-8 dr-leading-none flex items-center dr-h-32 dr-cursor-pointer ${
          hasFilledSa
            ? "dr-bg-darwin-touch-green-bg-light hover:dr-bg-darwin-touch-green-bg-dark hover:dr-border-darwin-touch-green-primary"
            : ""
        } ${className} ${getAclViewClassName(SUBJECT_KEYS.SA)} dr-max-w-135`}
      >
        <NoteMedicalRegularIcon
          className={`dr-w-16 dr-h-16 dr-min-w-16 dr-text-darwin-touch-neutral-400`}
        />
        <div className="flex-1">
          {hasFilledSa ? (
            <div className="flex items-center space-x-8 flex-1">
              <div className="flex-1">Assessment</div>
              <CircleCheckSolidIcon className="dr-w-16 dr-h-16 dr-text-darwin-touch-green-dark" />
            </div>
          ) : (
            <div className=" flex items-center space-x-8 flex-1">
              <div className="flex-1 dr-line-clamp-1">Assessment</div>
              <ClockSolidIcon className="dr-w-16 dr-h-16 dr-text-darwin-touch-red-primary" />
            </div>
          )}
        </div>
      </div>
    </TooltipComponent>
  );
};

export default SaQuestionnaireStatus;
